import { BadgeCheck, FileSearch, Handshake, IndianRupee, Scale, Users } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

const POINTS = [
  {
    icon: Scale,
    title: "Zero builder bias",
    body: "We are not a builder and we do not own inventory. Every recommendation is ranked on your brief, not on who pays the highest brokerage.",
  },
  {
    icon: IndianRupee,
    title: "Negotiated, transparent pricing",
    body: "Base rate, PLC, floor rise and hidden charges laid out side by side before you commit to anything.",
  },
  {
    icon: FileSearch,
    title: "Paper-first diligence",
    body: "RERA registration, title chain, approved layout and bank APF list — checked before a site visit is even booked.",
  },
  {
    icon: Users,
    title: "One advisor, start to registry",
    body: "The same advisor handles shortlisting, negotiation, home loan coordination and registry day.",
  },
];

const STRIP = [
  { icon: BadgeCheck, k: "RERA-verified projects only" },
  { icon: Handshake, k: "No charge for buyer advisory" },
  { icon: Users, k: "Chauffeured site visits" },
];

export const TrustMatrix = () => (
  <section id="advantage" data-testid="advantage-section" className="bg-cloud py-20 lg:py-28">
    <div className="mx-auto max-w-[1280px] px-5 lg:px-8">
      <Reveal>
        <SectionLabel index="02">The consultancy difference</SectionLabel>
        <h2 className="mt-5 max-w-2xl font-display text-3xl font-extrabold leading-tight text-ink sm:text-4xl">
          A builder sells you their project. We help you choose between all of them.
        </h2>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2">
        {POINTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.06}>
            <div className="card-soft card-hover h-full p-7">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-mint">
                <p.icon className="h-5 w-5 text-brandDark" />
              </span>
              <h3 className="mt-5 font-display text-lg font-bold text-ink">{p.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-body">{p.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="card-soft mt-5 flex flex-wrap gap-x-10 gap-y-4 px-7 py-6">
          {STRIP.map((s) => (
            <div key={s.k} className="flex items-center gap-2.5">
              <s.icon className="h-4 w-4 text-brand" />
              <span className="text-sm font-semibold text-ink2">{s.k}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
